import { Menu, MenuItem } from "@mui/material";
import Button from "../button";
import React from "react";
import { BiDotsVerticalRounded } from "react-icons/bi";

export interface IPropsSubMenuCards {
  recap: () => void;
  executeScheduled: () => void;
  executeImmediate: () => void;
  disabled: boolean
}

const ITEM_HEIGHT = 48;
export default function CardSubmenu(props: IPropsSubMenuCards) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button onClick={handleClick} disabled={props.disabled}>
        <BiDotsVerticalRounded size={22} color="#000000de" />
      </Button>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 3.5,
          },
        }}
      >
        <MenuItem
          key={"edit"}
          onClick={() => {
            props.recap();
            handleClose();
          }}
        >
          Executar Repescagem
        </MenuItem>
        <MenuItem
          key={"edit"}
          onClick={() => {
            props.executeScheduled();
            handleClose();
          }}
        >
          Executar Agendadas
        </MenuItem>
        <MenuItem
          key={"edit"}
          onClick={() => {
            props.executeImmediate();
            handleClose();
          }}
        >
          Executar Imediatas
        </MenuItem>
      </Menu>
    </div>
  );
}
